import { FC } from 'react';

import { Flex } from 'antd';
import classNames from 'classnames';

import CheckboxFormItem from '@/components/form/form-items/default-items/checkbox-form-item/CheckboxFormItem';

import styles from './DebtsInstructions.module.scss';

export const DebtsInstructions: FC = () => {
	return (
		<Flex className={styles['container']} gap={10} vertical>
			<span className={classNames(styles['text'], styles['title'])}>Instructions</span>
			<div className={styles['body']}>
				<span className={classNames(styles['text'], styles['text-body'])}>
					To be Completed by applicant business owner. Please list all outstanding debts of the
					business and provide all requested information.
				</span>
				<div className={styles['checkbox-row']}>
					<CheckboxFormItem
						className={styles['checkbox']}
						name="noOutstandingDebts"
						required={false}
					>
						<span className={classNames(styles['text'], styles['checkbox-text'])}>
							If your business has no outstanding debts, please check this box and sign and date at
							the bottom of the page
						</span>
					</CheckboxFormItem>
				</div>
			</div>
		</Flex>
	);
};
